import { Stack } from "@mui/material";
import { TechnicalConfigTabHeader } from "features/shared/components/technical-config-tab/TechnicalConfigTabHeader";
import { useState } from "react";

import type { WindowTypeGroup } from "../model/types";

import { useDeleteWindowConfig, useGetWindowTypeGroups } from "../api/hooks";
import { WindowCatalogDrawer } from "./WindowCatalogDrawer";
import { WindowConfigDrawer } from "./WindowConfigDrawer";
import { WindowGroupTable } from "./WindowGroupTable";
export const WindowTab = ({ projectId }: { projectId: string }) => {
  const { data: rows = [], isLoading } = useGetWindowTypeGroups(projectId);
  const { mutate: deleteConfig } = useDeleteWindowConfig();
  const [selectedGroup, setSelectedGroup] = useState<null | WindowTypeGroup>(null);
  const [catalogOpen, setCatalogOpen] = useState(false);

  const handleDelete = (group: WindowTypeGroup) => {
    if (!group.hasTechnology) return;
    deleteConfig({ projectId, userDefinedType: group.userDefinedType }, { onSuccess: () => setSelectedGroup(null) });
  };

  return (
    <Stack className="w-full flex-col items-stretch gap-6">
      <TechnicalConfigTabHeader
        descriptionKey="TechnicalData.windows.description"
        manageCatalogKey="TechnicalData.windows.manageTypePools"
        onManageCatalog={() => setCatalogOpen(true)}
        titleKey="TechnicalData.windows.title"
      />
      <WindowGroupTable groups={rows} isLoading={isLoading} onConfigure={setSelectedGroup} onDelete={handleDelete} />
      <WindowConfigDrawer
        group={selectedGroup}
        onClose={() => setSelectedGroup(null)}
        open={Boolean(selectedGroup)}
        projectId={projectId}
      />
      <WindowCatalogDrawer onClose={() => setCatalogOpen(false)} open={catalogOpen} />
    </Stack>
  );
};
